const map = {
	"./board/corner-bottom-left.png": 5629,
	"./board/corner-bottom-right.png": 2996,
	"./board/corner-top-left.png": 5093,
	"./board/corner-top-right.png": 4812,
	"./board/hole.png": 1078,
	"./board/plank-bottom.png": 8212,
	"./board/plank-left.png": 2114,
	"./board/plank-right.png": 8161,
	"./board/plank-top.png": 3154,
	"./buttons/button-large-border.png": 4766,
	"./buttons/button-medium-border.png": 2746,
	"./buttons/button-nav-border.png": 2056,
	"./flag/flag-normal.png": 4218,
	"./flag/flag-ripped.png": 1207,
	"./gems/border-default.png": 2868,
	"./gems/broken-shadow.png": 9710,
	"./gems/gem-apple.png": 7096,
	"./gems/gem-blue.png": 3700,
	"./gems/gem-bone.png": 9734,
	"./gems/gem-brick.png": 5423,
	"./gems/gem-bronze.png": 2304,
	"./gems/gem-caviar.png": 4134,
	"./gems/gem-cheese.png": 8743,
	"./gems/gem-coral.png": 8687,
	"./gems/gem-foam.png": 3935,
	"./gems/gem-football.png": 1739,
	"./gems/gem-geode.png": 6882,
	"./gems/gem-gold-stone.png": 598,
	"./gems/gem-gold.png": 9406,
	"./gems/gem-golf.png": 648,
	"./gems/gem-grass.png": 3330,
	"./gems/gem-green.png": 1245,
	"./gems/gem-honey.png": 4473,
	"./gems/gem-ice.png": 2977,
	"./gems/gem-lava.png": 4438,
	"./gems/gem-marble.png": 3299,
	"./gems/gem-neutral.png": 3145,
	"./gems/gem-onion.png": 5915,
	"./gems/gem-orange.png": 2866,
	"./gems/gem-paua.png": 3627,
	"./gems/gem-pearl.png": 4292,
	"./gems/gem-pinecone.png": 9751,
	"./gems/gem-pumpkin.png": 5024,
	"./gems/gem-purple.png": 8882,
	"./gems/gem-red.png": 6561,
	"./gems/gem-scarab.png": 9114,
	"./gems/gem-silver-stone.png": 7635,
	"./gems/gem-silver.png": 2211,
	"./gems/gem-slime.png": 4608,
	"./gems/gem-star.png": 6424,
	"./gems/gem-sushi.png": 8386,
	"./gems/gem-tennis.png": 1457,
	"./gems/gem-void.png": 3922,
	"./gems/gem-vortex.png": 4436,
	"./gems/gem-wood.png": 6583,
	"./gems/gem-yarn.png": 8726,
	"./gems/gem-yellow.png": 2160,
	"./logo.png": 9298,
	"./logo/logo-full.png": 1146,
	"./panel/panel-border-bottom.png": 5621,
	"./panel/panel-border-left.png": 8939,
	"./panel/panel-border-right.png": 4978,
	"./panel/panel-border-top.png": 9645,
	"./panel/store-tablet-landscape.png": 3290,
	"./round-button/round-button-bg-pressed.png": 4013,
	"./round-button/round-button-bg.png": 3884
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2012;